import {
  coreExtensionData,
  createExtensionBlueprint,
  ExtensionBoundary,
} from '@backstage/frontend-plugin-api';

/**
 * Une section de la page « Mon profil ». La page appartient au socle
 * (`page:platform/profile`), les sections appartiennent aux modules : le
 * changement de mot de passe Keycloak est fourni par `keycloak-admin`, si
 * bien qu'un client sans Keycloak n'a pas de bouton qui appelle un backend
 * absent. Même mécanique que `DashboardWidgetBlueprint`.
 */
export const ProfileSectionBlueprint = createExtensionBlueprint({
  kind: 'profile-section',
  attachTo: { id: 'page:platform/profile', input: 'sections' },
  output: [coreExtensionData.reactElement],
  factory(params: { loader: () => Promise<JSX.Element> }, { node }) {
    return [
      coreExtensionData.reactElement(ExtensionBoundary.lazy(node, params.loader)),
    ];
  },
});
